import qs from 'qs';

export function AddParams(uri: string, newParams: Record<string, string>) {
    const hashIndex = uri.indexOf('#');
    let hash = '';
    if (hashIndex !== -1) {
        hash = uri.slice(hashIndex);
        uri = uri.slice(0, hashIndex);
    }

    const params: Record<string, unknown> = {};

    const qIndex = uri.indexOf('?');
    if (qIndex !== -1) {
        const oldParams = qs.parse(uri.slice(qIndex + 1));
        for (const k of Object.keys(oldParams)) {
            params[k] = oldParams[k];
        }

        uri = uri.slice(0, qIndex);
    }

    for (const k of Object.keys(newParams)) {
        params[k] = newParams[k];
    }

    if (Object.keys(newParams).length) {
        uri += `?${qs.stringify(params, { arrayFormat: 'repeat' })}`;
    }

    if (hash) {
        uri += hash;
    }

    return uri;
}

export function ProdBaseURLToDev(uri: string): string {
    if (window.location.protocol === 'https:') {
        return uri;
    }

    const u = new URL(uri);
    u.protocol = 'http:';

    // not exhaustive, add as needed!
    switch (u.hostname) {
    case 'lapelpinsplus.com':
        u.host = 'lapelpinsplus.localhost';
        u.port = '10516';
        break;
    case 'allaboutchallengecoins.com':
    case 'my.allaboutchallengecoins.com':
        u.host = 'allaboutchallengecoins.localhost';
        u.port = '10501';
        break;
    case 'allaboutpins.com':
    case 'my.allaboutpins.com':
        u.host = 'allaboutpins.localhost';
        u.port = '10502';
        break;
    case 'allaboutpatches.com':
    case 'my.allaboutpatches.com':
        u.host = 'allaboutpatches.localhost';
        u.port = '10503';
        break;
    case 'allaboutlanyards.com':
    case 'my.allaboutlanyards.com':
        u.host = 'allaboutlanyards.localhost';
        u.port = '10504';
        break;
    case 'pindepot.com':
        u.host = 'pindepot.localhost';
        u.port = '10511';
        break;
    case 'coindepot.com':
        u.host = 'coindepot.localhost';
        u.port = '10517';
        break;
    case 'patchdepot.com':
        u.host = 'patchdepot.localhost';
        u.port = '10512';
        break;
    case 'lanyarddepot.com':
        u.host = 'lanyarddepot.localhost';
        u.port = '10513';
        break;
    }

    return u.toString();
}